import EnvContext from '@/providers/EnvContext';
import { useContext } from 'react';

export default function useEnv() {
  return useContext(EnvContext);
}
